import React from "react";
import "./Boosts_Your_Business.css";
import Boosts_Your_Business_card from "./Boosts_Your_Business_card/Boosts_Your_Business_card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination } from "swiper/modules";

function Boosts_Your_Business() {
  return (
    <>
      <section className="Boosts_Your_Business">
        <div className="container">
          <div className="Boosts_Your_Business_holder">
            <div className="bg-img-holder">
              <img
                className="bg-img"
                src={
                  process.env.PUBLIC_URL +
                  "/Assets/Images/Service/Services/Boosts_Your_Business/bg_img.png"
                }
                alt="bg-img"
              />

              <div className="overlay-holder"></div>
            </div>
            <div className="content-holder">
              <div className="content-heading-holder">
                <h1>How Videowala Bus Stand Boosts Your Business</h1>
              </div>

              <div className="Boosts_Your_Business_card_holder">
                <Swiper
                  slidesPerView={4}
                  spaceBetween={30}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  modules={[Pagination]}
                  className="mySwiper Boosts_Your_Business_card_swiper"
                  breakpoints={{
                    0: { slidesPerView: 1, spaceBetween: 30 },
                    321: { slidesPerView: 1, spaceBetween: 30 },
                    485: { slidesPerView: 2, spaceBetween: 30 },
                    576: { slidesPerView: 2, spaceBetween: 30 },
                    765: { slidesPerView: 2, spaceBetween: 30 },
                    992: { slidesPerView: 3, spaceBetween: 30 },
                    1024: { slidesPerView: 3, spaceBetween: 30 },
                    1200: { slidesPerView: 3, spaceBetween: 30 },
                    1400: { slidesPerView: 4, spaceBetween: 30 },
                  }}
                >
                  <SwiperSlide>
                    <Boosts_Your_Business_card
                      imgSrc={
                        "/Assets/Images/Service/Services/Boosts_Your_Business/Increased_Market_Penetration.png"
                      }
                      headingText={"Increased Market Penetration"}
                      discriptionText={"Gain access to urban and rural markets"}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Boosts_Your_Business_card
                      imgSrc={
                        "/Assets/Images/Service/Services/Boosts_Your_Business/high_recall.png"
                      }
                      headingText={"Improved Brand Recall"}
                      discriptionText={
                        "Regular exposure at high-traffic locations enhances audience familiarity with your brand."
                      }
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Boosts_Your_Business_card
                      imgSrc={
                        "/Assets/Images/Service/Services/Boosts_Your_Business/Better_ROI.png"
                      }
                      headingText={"Better ROI"}
                      discriptionText={
                        "With competitive rates and extensive reach, your ad spend translates into measurable results."
                      }
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Boosts_Your_Business_card
                      imgSrc={
                        "/Assets/Images/Service/Services/Boosts_Your_Business/Enhanced_Customer_Connection.png"
                      }
                      headingText={"Enhanced Customer Connection"}
                      discriptionText={
                        "By advertising in public spaces frequented by diverse audiences, your brand builds a closer connection with potential customers."
                      }
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Boosts_Your_Business;
